import { Action } from 'redux';
import { PaymentStateStructure } from '../../angular-elements/shared/interfaces/paymentStateStructure.interface';

export class PayloadAction implements Action {
  type: string;
  paymentStateStructure?: PaymentStateStructure;
}

const INITIAL_STATE: PaymentStateStructure = {
  billMe: ''
};

export const LOAD_PAYMENT = 'LOAD_PAYMENT';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
const RESET_STATE = 'RESET_STATE_Payment';

export function loadPayment(info: PaymentStateStructure): PayloadAction {
  return {
    type: LOAD_PAYMENT,
    paymentStateStructure: info
  };
}

export function resetPayment(): PayloadAction {
  return { type: RESET_STATE };
}

export function Payment( state: PaymentStateStructure = INITIAL_STATE, action: PayloadAction ) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case LOAD_PAYMENT:
      copiedState.billMe = action.paymentStateStructure.billMe;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
      return state;
  }
}

